module.exports = __webpack_public_path__ + "img/6.705db26d.png";